import { useEffect, useState } from "react";
import { secondsLeft } from "./seconds-left";

/**
 * Секунды до момента `until` (мс эпохи), тикающие раз в секунду.
 *
 * Отсчёт ведётся от `Date.now()`, а не декрементом счётчика: вкладка в фоне
 * получает тики реже секунды, и счётчик-декремент после возврата показывал бы
 * «осталось 40» там, где кнопка уже минуту как разблокирована.
 *
 * `until = null` выключает таймер и возвращает 0.
 */
export function useCountdown(until: number | null): number {
	const [left, setLeft] = useState(() => (until === null ? 0 : secondsLeft(until, Date.now())));

	useEffect(() => {
		if (until === null) {
			setLeft(0);
			return;
		}
		const tick = () => setLeft(secondsLeft(until, Date.now()));
		tick();
		const id = window.setInterval(tick, 1000);
		return () => window.clearInterval(id);
	}, [until]);

	return left;
}
